import { render, staticRenderFns } from "./MessCard.vue?vue&type=template&id=5b6ffb38&scoped=true&"
import script from "./MessCard.vue?vue&type=script&lang=js&"
export * from "./MessCard.vue?vue&type=script&lang=js&"
import style0 from "./MessCard.vue?vue&type=style&index=0&id=5b6ffb38&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6ffb38",
  null
  
)

export default component.exports